import './app.css';

import WebFont from 'webfontloader';
import {analyticsEvent, attrEvents} from './js/analytics';
import Swiper from 'swiper';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* fonts */
WebFont.load({
    custom: {
        families: ['CorsicaRamblerLX:n3,n4,n5'],
        urls: ['./css/fonts.css']
    },
    /*
    google: {
        families: ['Roboto:400,700:cyrillic']
    },*/
    typekit: {
        id: 'ejw5ayt'
    }
});

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
/* <button data-event="click" data-event-category="Button" data-event-label="Play"> */
analyticsEvent();
attrEvents();

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    import(/* webpackPrefetch: true */ './js/sw').then(func => {
        func.default();
    });
}

/* lazy loading (https://github.com/verlok/lazyload) */
if (document.querySelector('.lazy') !== null) {
    import(/* webpackPrefetch: true */ './js/lazyloading').then(func => {
        func.default();
    });
}

/* share buttons */
if (document.querySelector('.share') !== null) {
    import(/* webpackPrefetch: true */ './js/share').then(func => {
        func.default();
    });
}

let throttle = false;
const currentDate = new Date();
const gifts = [...document.querySelectorAll('.gift[data-items]')];

gifts.forEach(gift => {
    const giftDate = new Date(2019, 11, gift.dataset.id);

    if (currentDate >= giftDate) {
        gift.setAttribute('data-available', 'true');

        gift.addEventListener('click', () => {
            gift.setAttribute('data-open', 'true');

            if (parseInt(gift.dataset.count) > 1) {
                new Swiper(gift.querySelector('.swiper-container'), {
                    slidesPerView: 1,
                    centeredSlides: true,
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false
                    }
                });
            }

            analyticsEvent('Gift', 'click', 'Open Day: ' + gift.dataset.id);
        });
    }

    gift.addEventListener('click', evt => {
        if (!throttle && evt.detail === 3) {
            gift.setAttribute('data-open', 'true');

            if (parseInt(gift.dataset.count) > 1) {
                new Swiper(gift.querySelector('.swiper-container'), {
                    slidesPerView: 1,
                    centeredSlides: true,
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    autoplay: {
                        delay: 1000,
                        disableOnInteraction: false
                    }
                });
            }

            throttle = true;

            setTimeout(function() {
                gift.removeAttribute('data-open');
                throttle = false;
            }, 3000);
        }
    });
});

/* links */
const giftsLinks = [...document.querySelectorAll('.item__link')];

giftsLinks.forEach(link => {
    link.addEventListener('click', () => {
        analyticsEvent('Link', 'click', 'Link Text: ' + link.textContent);
    });
});
